module.exports = __webpack_public_path__ + "img/kj_images_02.3eee1194.png";